'use client';

/* eslint-disable @next/next/no-img-element -- The accordion icon does not need the stateful shared Image fallback. */

import { useState, type ReactNode } from 'react';

interface SelfExclusionAccordionProps {
  children: ReactNode;
  chevronClassName: string;
  contentClassName: string;
  headingClassName: string;
  itemClassName: string;
  title: string;
  triggerClassName: string;
}

export const SelfExclusionAccordion = ({
  children,
  chevronClassName,
  contentClassName,
  headingClassName,
  itemClassName,
  title,
  triggerClassName,
}: SelfExclusionAccordionProps) => {
  const [expanded, setExpanded] = useState(false);
  const contentId = 'footer-self-exclusion-content';

  return (
    <section className={itemClassName} data-expanded={expanded}>
      <button
        aria-controls={contentId}
        aria-expanded={expanded}
        className={triggerClassName}
        onClick={() => setExpanded((current) => !current)}
        type="button"
      >
        <span className={headingClassName}>{title}</span>
        <img
          alt=""
          aria-hidden="true"
          className={chevronClassName}
          height={16}
          loading="lazy"
          src="/images/icons/caretDown.svg"
          width={16}
        />
      </button>
      <div className={contentClassName} hidden={!expanded} id={contentId}>
        {children}
      </div>
    </section>
  );
};
